export const validatePublicCommentAttachments = (attachments: File[]): string => {
    const anyAttachmentNameIsLongerThan100 = attachments.some((attachment) => attachment.name.length > 100);
    if (anyAttachmentNameIsLongerThan100) {
        return "Attachment name cannot be longer than 100 characters";
    }
    return "";
};
